import { initialState, DocumentState } from 'app/modules/document/service/store/state';
import { ACTION_TYPES } from 'app/modules/document/service/store/actions';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/util/action-type.util';

export default (state: DocumentState = initialState, action): DocumentState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.GET_DOCUMENTS):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.GET_DOCUMENTS): {
      return {
        ...state,
        loading: false,
        documentModel: { ...state.documentModel, documentList: action.payload.data },
      };
    }

    case FAILURE(ACTION_TYPES.GET_DOCUMENTS): {
      return {
        ...initialState,
        loading: false,
      };
    }

    case REQUEST(ACTION_TYPES.UPLOAD_DOCUMENTS):
      return {
        ...state,
        loading: true,
        isLoading: true,
      };

    case SUCCESS(ACTION_TYPES.UPLOAD_DOCUMENTS): {
      return {
        
        ...state,
        uploadDocuments: action.payload.data,
        loading: false,
        isLoading: false,
      };
    }

    case FAILURE(ACTION_TYPES.UPLOAD_DOCUMENTS): {
      return {
        ...initialState,
        loading: false,
        isLoading: false,
      };
    }

    case REQUEST(ACTION_TYPES.GET_PAPERANDDOC):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.GET_PAPERANDDOC): {
      return {
        ...state,
        loading: false,
        PaperDocument: action.payload.data,
      };
    }

    case FAILURE(ACTION_TYPES.GET_PAPERANDDOC): {
      return {
        ...initialState,
        loading: false,
      };
    }

    default:
      return state;
  }
};
